import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiError } from '@/modules/common/hooks/use-api-error';

import { deleteElement } from '../api/reports.api';
import { REPORT_DETAIL_QUERY_KEY } from '../constants/reports-query-keys';

export const useDeleteElement = () => {
  const queryClient = useQueryClient();
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: ({ reportId, elementId }: { reportId: string; elementId: string }) =>
      deleteElement(reportId, elementId),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: REPORT_DETAIL_QUERY_KEY(variables.reportId) });
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(
        error,
        'authenticated.reports:toasts.elementDeleteError'
      );
    },
  });
};
